const UPDATE_URL = "/users/admin-reset";

export async function adminUpdateUser(axiosPrivate, userData, _id) {
  try {
    console.log(`${UPDATE_URL}/${_id}`);
    const response = await axiosPrivate.put(`${UPDATE_URL}/${_id}`, userData);
    return response;
  } catch (error) {
    // Create a custom error message without exposing request data
    const customError = {
      message: error.message,
      status: error.response ? error.response.status : null,
      statusText: error.response ? error.response.statusText : null,
    };

    console.error("Error updating user:", customError);
    return customError;
  }
}
